<template>
  <div class="container_view">
    <v-card class="content_card" elevation="10" variant="flat">
      <div>
        <header>
          <v-card-title> Minutas </v-card-title>
          <v-divider class="mx-3"></v-divider>
        </header>
      </div>
      <div class="content_accion">
        <div>
          <v-text-field
            v-model="search"
            label="Búsqueda"
            prepend-inner-icon="mdi-magnify"
            single-line
            variant="outlined"
            hide-details
            class="filter"
          ></v-text-field>
        </div>
        <div>
          <v-btn
            icon="mdi-reload"
            size="small"
            variant="outlined"
            color="indigo-darken-3"
            class="mr-2"
            @click="getMinutas()"
          >
          </v-btn>
        </div>
      </div>
      <div class="container_table">
        <v-data-table
          class="content_table"
          :headers="headerMinutas"
          fixed-header
          :items="listAllMinutas"
          :search="search"
          :loading="loadingMinutas"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <tr>
              <td>
                <div class="actions">
                  <div class="actions">
                    <v-tooltip activator="parent" location="top">Ver</v-tooltip>
                    <v-btn
                      class="edit"
                      icon="mdi-eye"
                      color="indigo-darken-3"
                      @click="openDialogRegistrar(item)"
                    ></v-btn>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <AlertComponent :value="dialogData" />
    <SnackbarComponent :value="snackbarData" />
  </div>

  <!-- Dialog de registro-->
  <template>
    <v-dialog width="650" v-model="showDialogRegistrar">
      <v-card title="Visualizar Minuta">
        <v-divider class="mx-3"></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <label>Lugar</label>
                <v-text-field
                  class="text-color"
                  id="lugarMinuta"
                  v-model="lugarMinuta"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Fecha de Reunión</label>
                <v-text-field class="text-color" v-model="fechaMinuta" readonly>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Asistentes Internos</label>
                <v-autocomplete
                  v-model="idUsuario"
                  variant="outlined"
                  :items="listUsers"
                  item-title="nombre"
                  item-value="id"
                  prepend-inner-icon="mdi-magnify"
                  chips
                  closable-chips
                  multiple
                  readonly
                  class="text-color"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <label>Asistentes Externos</label>
                <v-text-field class="text-color" v-model="usuariosC" readonly>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Objetivo</label>
                <v-textarea
                  class="text-color"
                  v-model="objetivoMinuta"
                  readonly
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <label>Temas a Discutir</label>
                <v-textarea
                  class="text-color"
                  readonly
                  v-model="temasDiscusion"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <label>Asuntos</label>
                <v-textarea
                  class="text-color"
                  readonly
                  v-model="asuntosMinutas"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            @click="closeDialogRegistrar"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
</template>

<script>
import { MinutasService } from "@/services/MinutasService";
import AlertComponent from "@/components/Alert.vue";
import SnackbarComponent from "@/components/Snackbar.vue";

export default {
  name: "NoticeSupervisorComponent",
  components: {
    AlertComponent,
    SnackbarComponent,
  },
  data() {
    return {
      loadingMinutas: true,
      listAllMinutas: [],
      headerMinutas: [
        { title: "Objetivo", key: "objetivo_minuta" },
        { title: "Lugar", key: "lugar_minuta" },
        { title: "Fecha de Reunión", key: "fecha_minuta" },
        { title: "Actualizado Por", key: "ultimaActualizacion" },
        { title: "Acciones", key: "actions" },
      ],
      dialogData: {
        openDialog: false,
        title: "",
        description: "",
        icon: "",
      },
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      search: "",
      showDialogRegistrar: false,
      idMinutaGlobal: "",
      lugarMinuta: "",
      fechaMinuta: "",
      objetivoMinuta: "",
      asuntosMinutas: "",
      temasDiscusion: "",
      asistentesMinuta: "",
      idUsuario: [],
      usuariosC: "",
    };
  },
  beforeMount() {
    this.getMinutas();
    this.getUsers();
  },
  methods: {
    getMinutas: async function () {
      this.loadingMinutas = true;
      await MinutasService.getAllMinutas()
        .then((resp) => {
          if (!resp.error) {
            this.listAllMinutas = resp.response;
            this.listAllMinutas.forEach((element) => {
              if (element.editado_por !== null) {
                element.ultimaActualizacion = element.editado_por;
              } else {
                element.ultimaActualizacion = element.agregado_por;
              }
            });
            setTimeout(() => {
              this.loadingMinutas = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
      this.search = "";
    },
    openDialogRegistrar(data) {
      this.idMinutaGlobal = data.id_minuta;
      this.lugarMinuta = data.lugar_minuta;
      this.fechaMinuta = data.fecha_minuta;
      this.objetivoMinuta = data.objetivo_minuta;
      this.asuntosMinutas = data.asuntos;
      this.temasDiscusion = data.temas_discusion;
      this.asistentesMinuta = data.asistentes.split(",");
      this.asistentesMinuta.forEach((element) => {
        const usuario = this.listUsers.find((user) => user.nombre === element);
        if (usuario) {
          this.idUsuario[usuario.id] = usuario.id;
        } else {
          this.usuariosC += element + ", ";
        }
      });
      this.showDialogRegistrar = true;
    },
    closeDialogRegistrar() {
      this.showDialogRegistrar = false;
      this.lugarMinuta = "";
      this.fechaMinuta = "";
      this.idUsuario = [];
      this.usuariosC = "";
      this.asistentesMinuta = "";
      this.objetivoMinuta = "";
      this.asuntosMinutas = "";
      this.temasDiscusion = "";
    },
    getUsers: async function () {
      await MinutasService.getUsers()
        .then((resp) => {
          if (!resp.error) {
            this.listUsers = resp.response;
            this.listUsers.forEach((element) => {
              element.nombre = element.name + " " + element.last_name;
            });
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
  },
};
</script>

<style scoped>
.filter {
  width: 300px;
}

.content_table {
  overflow: auto;
}

.content_accion {
  padding-bottom: 10px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.content_load {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.select {
  float: left;
  margin-right: 2vh;
  width: 60vh;
}

.buscar {
  float: left;
  margin-right: 2vh;
  width: 20vh;
}

.text-color {
  color: #000000;
}
</style>
